// Reading history
import { API_BASE, fullReadingHistory, historyExpanded, setFullReadingHistory, setHistoryExpanded } from './state.js';
import { formatRelativeTime, escapeHtml, showToast } from './utils.js';

export function renderReadingHistory(history, expanded) {
  setFullReadingHistory(history);
  setHistoryExpanded(expanded || false);
  
  const container = document.getElementById('reading-history-list');
  const clearBtn = document.getElementById('clear-history-btn');
  if (!container) return;
  
  if (history.length === 0) {
    container.innerHTML = '<div class="history-empty"><div class="history-empty-icon">📖</div><div>No reading history yet</div></div>';
    if (clearBtn) clearBtn.style.display = 'none';
    return;
  }
  
  if (clearBtn) clearBtn.style.display = 'inline-block';
  
  const displayItems = historyExpanded ? history : history.slice(0, 9);
  const hasMore = history.length > 9;
  
  let html = displayItems.map(item => 
    '<div class="history-item" data-story-id="' + item.storyId + '">' +
    '<div class="history-item-content">' +
    '<div class="history-item-headline">' + escapeHtml(item.headline) + '</div>' +
    '<div class="history-item-meta">' +
    '<span class="history-item-category">' + (item.category || 'news') + '</span>' +
    '<span>·</span>' +
    '<span class="history-item-time">' + formatRelativeTime(item.readAt) + '</span>' +
    '</div></div>' +
    '<button class="history-item-remove" onclick="window.appRemoveFromHistory(\'' + item.storyId + '\')" title="Remove">' +
    '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">' +
    '<line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg></button></div>'
  ).join('');
  
  if (hasMore && !historyExpanded) {
    html += '<button class="history-see-more" onclick="window.appToggleHistoryExpand()">See ' + (history.length - 9) + ' more</button>';
  } else if (hasMore && historyExpanded) {
    html += '<button class="history-see-more" onclick="window.appToggleHistoryExpand()">Show less</button>';
  }
  
  container.innerHTML = html;
}

export function toggleHistoryExpand() {
  renderReadingHistory(fullReadingHistory, !historyExpanded);
}

export async function clearReadingHistory() {
  if (!confirm('Clear all reading history?')) return;
  
  try {
    const response = await fetch(API_BASE + '/history', { method: 'DELETE', credentials: 'include' });
    if (!response.ok) throw new Error('Failed to clear history');
    showToast('Reading history cleared');
    renderReadingHistory([]);
  } catch (error) {
    console.error('Failed to clear history:', error);
    showToast('Failed to clear history', 'error');
  }
}

export async function removeFromHistory(storyId) {
  try {
    const response = await fetch(API_BASE + '/history/' + storyId, { method: 'DELETE', credentials: 'include' });
    if (!response.ok) throw new Error('Failed to remove from history');
    
    const item = document.querySelector('.history-item[data-story-id="' + storyId + '"]');
    if (item) {
      item.style.opacity = '0';
      item.style.transform = 'translateX(20px)';
      setTimeout(() => item.remove(), 200);
    }
  } catch (error) {
    console.error('Failed to remove from history:', error);
    showToast('Failed to remove item', 'error');
  }
}
